/*eslint-disable*/ 
//This file was generated by `tools/generate-error-classes.ts`.
//Changes made to this file will be overwritten.
//Moreover, this file should be excluded from your linter, formatter and VCS.
import BaseError from "@/modules/errors/classes/BaseError.gen.ts";
export default class AuthStartupExpiredRefreshTokenError extends BaseError {
    constructor(originalError?: Error) { super(1001003003, "expired_refresh_token", "auth", "startup", "auth_startup_expired_refresh_token", originalError); }
}
